
import React, { useState } from "react";
import CustomDropdownTimePicker from "../../global/components/CustomDropdownTimePicker/CustomDropdownTimePicker";
import { DatePicker } from "@vds/date-pickers";
import "./search.css";

const Search_When = ({
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    timeRange,
    setTimeRange,
    setDateError,
    setTimeError,
}) => {
    const [toDateError, setToDateError] = useState("");
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    sevenDaysAgo.setHours(0, 0, 0, 0);

    const handleFromDateChange = (date) => {
        setFromDate(date);
        setToDate("");
        if (date) {
            setToDateError("Please select a To date");
            setDateError("Please select a To date");
        }
    };

    const handleToDateChange = (date) => {
        setToDate(date);
        if (date) {
            setToDateError("");
            setDateError("");
        }
    };

    const handleDateError = (error) => {
        setDateError(error || "");
    };

    return (
        <div className="search-when-container">
            <h2 className="search-when-title">When do you want to search?</h2>
            <div className="search-when-info">
                Time selection is limited to a 12 hr window
            </div>
            <div className="search-when-row">
                <div className="search-when-date-col">
                    <label className="search-when-label">From:</label>
                    <DatePicker
                        value={fromDate}
                        onChange={handleFromDateChange}
                        dateFormat="MM/DD/YYYY"
                        className="search-when-datepicker"
                        placeholder="Select date"
                        minDate={sevenDaysAgo}
                        maxDate={toDate ? new Date(toDate) : new Date()}
                        onError={handleDateError}
                    />
                </div>
                <div className="search-when-date-col">
                    <label className="search-when-label">To:</label>
                    <DatePicker
                        value={toDate}
                        onChange={handleToDateChange}
                        dateFormat="MM/DD/YYYY"
                        className="search-when-datepicker"
                        placeholder="Select date"
                        minDate={fromDate ? new Date(fromDate) : sevenDaysAgo}
                        maxDate={
                            fromDate && (Math.abs(new Date(fromDate) - new Date()) / (1000 * 60 * 60 * 24)) > 1
                                ? new Date(new Date(fromDate).getTime() + 24 * 60 * 60 * 1000)
                                : new Date()
                        }
                        onError={handleDateError}
                        errorText={toDateError}
                        error={!!toDateError}
                    />
                </div>
            </div>
            <h3 className="select-hours-label">Select hours:</h3>
            <div className="search-when-picker">
                <CustomDropdownTimePicker
                    from={timeRange.startTime}
                    to={timeRange.endTime}
                    onChange={setTimeRange}
                    errorCallback={setTimeError}
                    fromDate={fromDate}
                    toDate={toDate}
                />
            </div>
        </div>
    );
};

export default Search_When;